import { axiosGet, axiosPost } from '../../../services/ServiceBase';

/**
 * save reclamo
 * @returns
 */
export const saveReintegroService = async (reintegro) => {
  const salida = await axiosPost('/v1/reintegro', reintegro);
  return salida;
};

/**
 * get reclamos
 * @returns
 */
export const getReintegrosService = async () => {
  const salida = await axiosGet('/v1/reintegro');
  return salida;
};

/**
 * get reclamos
 * @returns
 */
export const getReintegroService = async (id) => {
  const salida = await axiosGet(`/v1/reintegro/${id}`);
  return salida;
};

/** anular reclamo
 * @returns
 */
export const anularReintegro = async (data) => {
  const salida = await axiosPost('/v1/reintegro/anular', data);
  return salida;
};
